import axios from 'axios';

const list = (data) => axios.get('/custom/information/list', data);
const save = (data) => axios.post('/custom/information/saveOrUpdate', data);
const del = (data) => axios.post('/custom/information/delete', data); //delete

export default {
  list,
  save,
  del,
}


